// import React, { useState } from "react";

import RandingStyle6 from "../../randing/RandingStyle6";

function Randing200({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle6
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/200/01.gif`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/068/25010902.png`}
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/068/25010903.jpg`} //질문
      formFieldColor="white"
      qOptionColor="red"
      privacyMessage="개인정보수집에 동의하시는 분만'신청하기'버튼을 눌러주세요."
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/costBenefitButton.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
    />
  );
}

export default Randing200;
